<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Reporte por Período
          <span class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            {{ etiquetaPeriodo }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          Panel administrativo - Filtra por rango de fechas
        </p>
      </div>

      <div class="flex flex-col sm:flex-row items-start sm:items-end gap-2 sm:gap-3 w-full sm:w-auto">
        <!-- 📅 Filtro DESDE -->
        <div class="flex-1 min-w-[160px] w-full sm:w-auto">
          <label class="block text-[10px] sm:text-xs font-bold text-gray-500 dark:text-gray-400 mb-1 uppercase">Desde</label>
          <input
            v-model="fechaDesde"
            type="date"
            class="w-full px-3 sm:px-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-800 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-sm font-medium text-gray-700 dark:text-gray-300"
            @change="cargarEstadisticasPorPeriodo"
          />
        </div>

        <!-- 📅 Filtro HASTA -->
        <div class="flex-1 min-w-[160px] w-full sm:w-auto">
          <label class="block text-[10px] sm:text-xs font-bold text-gray-500 dark:text-gray-400 mb-1 uppercase">Hasta</label>
          <input
            v-model="fechaHasta"
            type="date"
            class="w-full px-3 sm:px-4 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-800 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-sm font-medium text-gray-700 dark:text-gray-300"
            @change="cargarEstadisticasPorPeriodo"
          />
        </div>

        <!-- Botones rápidos -->
        <div class="flex gap-1">
          <button
            @click="setHoy"
            class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 transition-all shadow-sm whitespace-nowrap"
            title="Hoy"
          >
            Hoy
          </button>
          <button
            @click="setMesActual"
            class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 transition-all shadow-sm whitespace-nowrap"
            title="Mes actual"
          >
            Mes
          </button>
          <button
            @click="setAnioActual"
            class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 transition-all shadow-sm whitespace-nowrap"
            title="Año actual"
          >
            Año
          </button>
        </div>

        <!-- Botón Sincronizar -->
        <button
          @click="cargarEstadisticasPorPeriodo"
          class="px-3 sm:px-6 py-2 sm:py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-sm tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 w-full sm:w-auto justify-center"
          :disabled="cargandoStats"
        >
          <Icon icon="mdi:refresh" :class="{ 'animate-spin': cargandoStats }" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">{{ cargandoStats ? 'Cargando...' : 'Sincronizar' }}</span>
          <span class="sm:hidden">{{ cargandoStats ? '...' : 'Actualizar' }}</span>
        </button>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- TARJETAS DE RESUMEN -->
    <!-- ============================================================ -->
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-2 sm:gap-4 mb-3 sm:mb-6">
      <!-- 1. Servicios Taller -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-purple-100 dark:bg-purple-900/40 rounded-xl sm:rounded-2xl text-purple-600 dark:text-purple-300">
            <Icon icon="mdi:tools" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Servicios Taller (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsPeriodo.servicios.toFixed(2) }}</p>
      </div>

      <!-- 2. Productos Totales -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-blue-100 dark:bg-blue-900/40 rounded-xl sm:rounded-2xl text-blue-600 dark:text-blue-300">
            <Icon icon="mdi:cart-arrow-up" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Productos Totales (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsPeriodo.ventas.toFixed(2) }}</p>
      </div>

      <!-- 3. Recepciones Express -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-yellow-100 dark:bg-yellow-900/40 rounded-xl sm:rounded-2xl text-yellow-600 dark:text-yellow-300">
            <Icon icon="mdi:flash" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Recepciones Express (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsPeriodo.recepcionesExpress.toFixed(2) }}</p>
      </div>

      <!-- 4. Servicios Externos -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-cyan-100 dark:bg-cyan-900/40 rounded-xl sm:rounded-2xl text-cyan-600 dark:text-cyan-300">
            <Icon icon="mdi:home-outline" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Servicios Externos (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsPeriodo.serviciosExternos.toFixed(2) }}</p>
      </div>

      <!-- 5. Cashea Servicios -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-violet-100 dark:bg-violet-900/40 rounded-xl sm:rounded-2xl text-violet-600 dark:text-violet-300">
            <Icon icon="mdi:lightning-bolt" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Cashea (Servicios)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosServicios['Crédito Cashea'].toFixed(2) }}</p>
      </div>

      <!-- 6. Cashea Ventas -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-violet-100 dark:bg-violet-900/40 rounded-xl sm:rounded-2xl text-violet-600 dark:text-violet-300">
            <Icon icon="mdi:lightning-bolt" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Cashea (Ventas)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosVentas['Crédito Cashea'].toFixed(2) }}</p>
      </div>

      <!-- 7. Crédito Empresarial Servicios -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-orange-100 dark:bg-orange-900/40 rounded-xl sm:rounded-2xl text-orange-600 dark:text-orange-300">
            <Icon icon="mdi:domain" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Crédito Empresarial (Servicios)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosServicios['Crédito Empresarial'].toFixed(2) }}</p>
      </div>

      <!-- 8. Crédito Empresarial Ventas -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-orange-100 dark:bg-orange-900/40 rounded-xl sm:rounded-2xl text-orange-600 dark:text-orange-300">
            <Icon icon="mdi:domain" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Crédito Empresarial (Ventas)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosVentas['Crédito Empresarial'].toFixed(2) }}</p>
      </div>

      <!-- 9. Créditos Servicios Externos -->
      <div class="relative overflow-hidden group bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl transition-all hover:-translate-y-1">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl text-white">
            <Icon icon="mdi:home-wrench" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-2 py-1 bg-white/20 text-white rounded-lg">FIADO</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-amber-100/80 font-medium mb-0.5">Créditos Serv. Externos</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-white">${{ totalCreditosServiciosExternos.toFixed(2) }}</p>
        <div class="mt-2 text-[8px] sm:text-[10px] text-white/80 font-bold">
          <span><Icon icon="mdi:lightning-bolt" class="inline mr-1" /> Cashea: ${{ metodosServiciosExternos['Crédito Cashea'].toFixed(2) }}</span><br />
          <span><Icon icon="mdi:domain" class="inline mr-1" /> Empresarial: ${{ metodosServiciosExternos['Crédito Empresarial'].toFixed(2) }}</span>
        </div>
      </div>

      <!-- 10. Operaciones -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all hover:-translate-y-1 hover:shadow-2xl">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-emerald-100 dark:bg-emerald-900/40 rounded-xl sm:rounded-2xl text-emerald-600 dark:text-emerald-300">
            <Icon icon="mdi:account-group" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5">Operaciones Realizadas</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsPeriodo.conteo }}</p>
      </div>

      <!-- 11. Total Cobrado -->
      <div class="relative overflow-hidden group bg-gradient-to-br from-indigo-600 to-blue-700 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl transition-all hover:-translate-y-1">
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl text-white">
            <Icon icon="mdi:cash-multiple" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-2 py-1 bg-white/20 text-white rounded-lg">COBRO REAL</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-indigo-100/80 font-medium mb-0.5">Ingreso Cobrado</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-white">${{ totalPeriodo.toFixed(2) }}</p>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- MÉTODOS DE PAGO - VENTAS -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
        <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
          <Icon icon="mdi:cart-arrow-up" class="mr-2 text-blue-600" />
          Distribución de Ventas ({{ etiquetaPeriodo }})
        </h2>
        <div class="text-right bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30 rounded-xl px-3 sm:px-5 py-2">
          <p class="text-[8px] sm:text-[10px] text-blue-500 uppercase font-bold tracking-wider">Total Ventas</p>
          <p class="text-base sm:text-2xl font-black text-blue-600 dark:text-blue-400">${{ statsPeriodo.ventas.toFixed(2) }}</p>
        </div>
      </div>
      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosVentas"
          :key="'v-' + label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all"
          :class="[val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700' : 'bg-gray-50/40 dark:bg-gray-800/20 opacity-40']"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">${{ val.toFixed(2) }}</p>
              <p v-if="tasaUbcv && val > 0" class="text-[8px] sm:text-[10px] text-gray-400 truncate">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- MÉTODOS DE PAGO - SERVICIOS TALLER -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
        <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
          <Icon icon="mdi:tools" class="mr-2 text-purple-600" />
          Distribución de Servicios Taller ({{ etiquetaPeriodo }})
        </h2>
        <div class="text-right bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/30 rounded-xl px-3 sm:px-5 py-2">
          <p class="text-[8px] sm:text-[10px] text-purple-500 uppercase font-bold tracking-wider">Total Servicios</p>
          <p class="text-base sm:text-2xl font-black text-purple-600 dark:text-purple-400">${{ statsPeriodo.servicios.toFixed(2) }}</p>
        </div>
      </div>
      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosServicios"
          :key="'s-' + label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all"
          :class="[val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700' : 'bg-gray-50/40 dark:bg-gray-800/20 opacity-40']"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">${{ val.toFixed(2) }}</p>
              <p v-if="tasaUbcv && val > 0" class="text-[8px] sm:text-[10px] text-gray-400 truncate">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- MÉTODOS DE PAGO - RECEPCIONES EXPRESS -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
        <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
          <Icon icon="mdi:flash" class="mr-2 text-yellow-600" />
          Distribución de Recepciones Express ({{ etiquetaPeriodo }})
        </h2>
        <div class="text-right bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800/30 rounded-xl px-3 sm:px-5 py-2">
          <p class="text-[8px] sm:text-[10px] text-yellow-500 uppercase font-bold tracking-wider">Total Express</p>
          <p class="text-base sm:text-2xl font-black text-yellow-600 dark:text-yellow-400">${{ statsPeriodo.recepcionesExpress.toFixed(2) }}</p>
        </div>
      </div>
      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosRecepcionesExpress"
          :key="'e-' + label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all"
          :class="[val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700' : 'bg-gray-50/40 dark:bg-gray-800/20 opacity-40']"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">${{ val.toFixed(2) }}</p>
              <p v-if="tasaUbcv && val > 0" class="text-[8px] sm:text-[10px] text-gray-400 truncate">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- MÉTODOS DE PAGO - SERVICIOS EXTERNOS -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
        <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
          <Icon icon="mdi:home-wrench" class="mr-2 text-cyan-600" />
          Distribución de Servicios Externos ({{ etiquetaPeriodo }})
        </h2>
        <div class="text-right bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-100 dark:border-cyan-800/30 rounded-xl px-3 sm:px-5 py-2">
          <p class="text-[8px] sm:text-[10px] text-cyan-500 uppercase font-bold tracking-wider">Total Externos</p>
          <p class="text-base sm:text-2xl font-black text-cyan-600 dark:text-cyan-400">${{ statsPeriodo.serviciosExternos.toFixed(2) }}</p>
        </div>
      </div>
      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosServiciosExternos"
          :key="'ext-' + label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all"
          :class="[val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700' : 'bg-gray-50/40 dark:bg-gray-800/20 opacity-40']"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">${{ val.toFixed(2) }}</p>
              <p v-if="tasaUbcv && val > 0" class="text-[8px] sm:text-[10px] text-gray-400 truncate">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- TABLA DE SERVICIOS DEL PERÍODO -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:clipboard-list" class="mr-2 text-purple-600" />
            Registro de Servicios ({{ etiquetaPeriodo }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            <span class="font-bold text-purple-600">{{ serviciosDelPeriodo.length }}</span> servicios registrados
          </p>
        </div>
        <div class="text-right bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/30 rounded-xl px-3 sm:px-5 py-2">
          <p class="text-[8px] sm:text-[10px] text-purple-500 uppercase font-bold tracking-wider">Total Cobrado</p>
          <p class="text-base sm:text-2xl font-black text-purple-600 dark:text-purple-400">${{ totalServiciosCobrado.toFixed(2) }}</p>
        </div>
      </div>

      <!-- Filtros rápidos -->
      <div class="flex flex-wrap gap-2 mb-4">
        <button
          @click="filtroEstadoServicios = 'todos'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'todos' ? 'bg-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'"
        >
          Todos ({{ serviciosDelPeriodo.length }})
        </button>
        <button
          @click="filtroEstadoServicios = 'completado'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'completado' ? 'bg-emerald-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'"
        >
          ✅ Completados ({{ serviciosCompletados.length }})
        </button>
        <button
          @click="filtroEstadoServicios = 'pendiente'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'pendiente' ? 'bg-yellow-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'"
        >
          ⏳ Pendientes ({{ serviciosPendientes.length }})
        </button>
        <button
          @click="filtroEstadoServicios = 'externos'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'externos' ? 'bg-cyan-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'"
        >
          🔧 Externos ({{ serviciosExternosFiltrados.length }})
        </button>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-left text-[10px] sm:text-sm">
          <thead>
            <tr class="border-b border-gray-200 dark:border-gray-700">
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase">#</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase">Tipo</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase">Cliente</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase">Método Pago</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase text-right">Monto USD</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase text-right">Cobrado</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase text-right">Financiado</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase">Estado</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase">Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(servicio, index) in serviciosPaginados"
              :key="servicio.id || index"
              class="border-b border-gray-100 dark:border-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/20 transition-colors"
              :class="{ 'opacity-60': !servicio.estadoCompletado }"
            >
              <td class="py-2 sm:py-3 font-bold text-gray-800 dark:text-white">
                #{{ servicio.numeroOrden || servicio.id || 'N/A' }}
              </td>
              <td class="py-2 sm:py-3">
                <span
                  class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold"
                  :class="servicio.tipo === 'externo' ? 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400' : 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400'"
                >
                  {{ servicio.tipo === 'externo' ? 'Externo' : 'Taller' }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-gray-700 dark:text-gray-300">
                {{ servicio.clienteNombre || 'Cliente' }}
              </td>
              <td class="py-2 sm:py-3">
                <span class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold" :class="getMetodoPagoClass(servicio.metodoPago)">
                  {{ servicio.metodoPago || 'Efectivo' }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-right font-bold text-gray-800 dark:text-white">
                ${{ (servicio.totalServicio || 0).toFixed(2) }}
              </td>
              <td class="py-2 sm:py-3 text-right font-bold text-emerald-600 dark:text-emerald-400">
                ${{ (servicio.montoCobradoUsd || 0).toFixed(2) }}
              </td>
              <td class="py-2 sm:py-3 text-right">
                <span v-if="servicio.financiado > 0" class="text-orange-600 dark:text-orange-400 font-bold">
                  ${{ servicio.financiado.toFixed(2) }}
                </span>
                <span v-else class="text-gray-400">—</span>
              </td>
              <td class="py-2 sm:py-3">
                <span class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold" :class="getEstadoClass(servicio.estado)">
                  {{ servicio.estado || 'Pendiente' }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-gray-500 dark:text-gray-400 text-[10px]">
                {{ servicio.fechaIngreso ? formatFecha(servicio.fechaIngreso) : '—' }}
              </td>
            </tr>
            <tr v-if="serviciosPaginados.length === 0">
              <td colspan="9" class="py-6 text-center text-gray-400 dark:text-gray-500 text-xs sm:text-sm">
                <Icon icon="mdi:inbox-outline" class="text-3xl sm:text-4xl mx-auto mb-2 opacity-50" />
                No hay servicios registrados en este período
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      <div v-if="serviciosFiltrados.length > itemsPorPagina" class="mt-4 flex justify-between items-center">
        <button
          @click="paginaActual = Math.max(1, paginaActual - 1)"
          :disabled="paginaActual === 1"
          class="px-3 py-1 text-sm font-bold rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 disabled:opacity-50"
        >
          Anterior
        </button>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Página {{ paginaActual }} de {{ totalPaginas }}
        </span>
        <button
          @click="paginaActual = Math.min(totalPaginas, paginaActual + 1)"
          :disabled="paginaActual === totalPaginas"
          class="px-3 py-1 text-sm font-bold rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 disabled:opacity-50"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { obtenerVentas } from '@/api/ventas.js';
import { obtenerPagosVenta, obtenerPagosPorVenta } from '@/api/pagoVenta.js';
import { obtenerClientes } from '@/api/clientes.js';
import { obtenerTasaVentaActual } from '@/api/tasaVenta.js';
import apiServiciosExternos from '@/api/serviciosExternos.js';
import { obtenerPagosSalidaEquipo } from '@/api/pagoSalidaEquipo.js';
import apiRecepcion from '@/api/recepcionEquipo.js';
import { obtenerFinanciadoEquiposMinimo } from '@/api/creditoSalidaEquipo.js';

export default {
  name: 'ReporteAnualMensual',
  components: { Icon },
  data() {
    const hoy = new Date().toLocaleDateString('sv-SE');
    return {
      // 📅 Rango de fechas
      fechaDesde: hoy,
      fechaHasta: '',

      cargandoStats: false,
      filtroEstadoServicios: 'todos',
      paginaActual: 1,
      itemsPorPagina: 20,

      statsPeriodo: {
        ventas: 0,
        servicios: 0,
        recepcionesExpress: 0,
        serviciosExternos: 0,
        conteo: 0
      },

      ventasOriginales: [],
      serviciosOriginales: [],
      serviciosExternosOriginales: [],
      pagosServicios: [],
      clientesMap: new Map(),
      clientesPhoneMap: new Map(),
      tasaUbcv: null,

      metodosVentas: {
        'Efectivo Bs': 0, 'Efectivo USD': 0, 'Pago Móvil': 0, 'Punto de Venta': 0,
        'Transferencia Bs': 0, 'Transferencia USD': 0,
        'Crédito Cashea': 0, 'Crédito Empresarial': 0
      },
      metodosServicios: {
        'Efectivo Bs': 0, 'Efectivo USD': 0, 'Pago Móvil': 0, 'Punto de Venta': 0,
        'Transferencia Bs': 0, 'Transferencia USD': 0,
        'Crédito Cashea': 0, 'Crédito Empresarial': 0
      },
      metodosRecepcionesExpress: {
        'Efectivo Bs': 0, 'Efectivo USD': 0, 'Pago Móvil': 0, 'Punto de Venta': 0,
        'Transferencia Bs': 0, 'Transferencia USD': 0,
        'Crédito Cashea': 0, 'Crédito Empresarial': 0
      },
      metodosServiciosExternos: {
        'Efectivo Bs': 0, 'Efectivo USD': 0, 'Pago Móvil': 0, 'Punto de Venta': 0,
        'Transferencia Bs': 0, 'Transferencia USD': 0,
        'Crédito Cashea': 0, 'Crédito Empresarial': 0
      }
    };
  },
  computed: {
    // 🔥 Rango según las dos fechas
    rangoPeriodo() {
      const hoy = new Date().toLocaleDateString('sv-SE');
      let desde = this.fechaDesde || hoy;
      let hasta = this.fechaHasta || hoy;

      // Si solo hay "desde", filtra SOLO ese día
      if (this.fechaDesde && !this.fechaHasta) {
        hasta = this.fechaDesde;
      }

      // Si solo hay "hasta" (sin desde), usar desde = hoy
      if (!this.fechaDesde && this.fechaHasta) {
        desde = this.fechaHasta;
      }

      return { desde, hasta };
    },

    etiquetaPeriodo() {
      const { desde, hasta } = this.rangoPeriodo;

      if (desde === hasta) {
        const partes = desde.split('-');
        const d = new Date(partes[0], partes[1] - 1, partes[2]);
        const hoy = new Date();
        if (d.toDateString() === hoy.toDateString()) return 'HOY';
        return d.toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase();
      }

      const p1 = desde.split('-');
      const p2 = hasta.split('-');
      const d1 = new Date(p1[0], p1[1] - 1, p1[2]);
      const d2 = new Date(p2[0], p2[1] - 1, p2[2]);
      return `${d1.toLocaleDateString('es-VE', { day: '2-digit', month: 'short' })} - ${d2.toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' })}`.toUpperCase();
    },

    metodosReales() {
      return ['Efectivo Bs', 'Efectivo USD', 'Pago Móvil', 'Punto de Venta', 'Transferencia Bs', 'Transferencia USD'];
    },

    totalPeriodo() {
      let total = 0;
      for (const key of this.metodosReales) {
        total += this.metodosVentas[key] || 0;
        total += this.metodosServicios[key] || 0;
        total += this.metodosRecepcionesExpress[key] || 0;
        total += this.metodosServiciosExternos[key] || 0;
      }
      return total;
    },

    totalCreditosServiciosExternos() {
      return (this.metodosServiciosExternos['Crédito Cashea'] || 0) +
             (this.metodosServiciosExternos['Crédito Empresarial'] || 0);
    },

    serviciosDelPeriodo() {
      const { desde, hasta } = this.rangoPeriodo;
      const resultado = [];

      const estaEnRango = (fechaStr) => {
        if (!fechaStr) return false;
        const f = String(fechaStr).substring(0, 10);
        return f >= desde && f <= hasta;
      };

      // 1. SERVICIOS INTERNOS
      if (this.serviciosOriginales && this.serviciosOriginales.length > 0) {
        const pagosMap = new Map();
        for (const p of this.pagosServicios) {
          const key = p.idRecepcionEquipo || p.id_recepcion_equipo || p.idRecepcion;
          if (key) {
            if (!pagosMap.has(key)) pagosMap.set(key, []);
            pagosMap.get(key).push(p);
          }
        }

        for (const s of this.serviciosOriginales) {
          const fechaRef = s.fechaPago || s.fechaEntrega || s.fechaIngreso || '';
          const key = s.idRecepcionEquipo ?? s.id_recepcion_equipo ?? s.idRecepcion ?? s.id;
          const pagos = key ? (pagosMap.get(key) || []) : [];
          const pagosPeriodo = pagos.filter(p => estaEnRango(p.fechaPago || p.fecha_pago));
          const creditos = s.creditos || s.cuotas || s.creditosSalidaEquipo || s.cuotasCredito || [];
          const cuotasPeriodo = creditos.filter(c => estaEnRango(c.fechaPago || c.fecha_pago));

          const coincide = estaEnRango(fechaRef) || pagosPeriodo.length > 0 || cuotasPeriodo.length > 0;
          if (!coincide) continue;

          const totalServicio = parseFloat(s.precioTotalUsd || s.montoCobradoUsd || 0);
          let cobrado = pagosPeriodo.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
          cobrado += cuotasPeriodo.reduce((sum, c) => {
            return sum + (parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0);
          }, 0);

          const met = (s.metodoPago || '').toUpperCase();
          const esCredito = met.includes('CACHEA') || met.includes('EMPRESA') || met.includes('EMPRESARIAL') || met.includes('CORPORATIVO');
          let financiado = 0;
          if (esCredito) financiado = Math.max(0, totalServicio - cobrado);

          const estado = (s.nombreEstado || s.estado || '').toLowerCase();
          const estadoCompletado = estado.includes('entregado') || estado.includes('completado') ||
                                   estado.includes('finalizado') || estado.includes('cerrado');

          resultado.push({
            id: s.idRecepcionEquipo || s.id,
            numeroOrden: s.numeroOrden || s.idRecepcionEquipo || 'N/A',
            tipo: 'interno',
            clienteNombre: this.clientesMap.get(s.idCliente) || s.clienteNombre || 'Cliente',
            metodoPago: s.metodoPago || 'Efectivo',
            totalServicio,
            montoCobradoUsd: cobrado,
            financiado,
            estado: s.nombreEstado || s.estado || 'Pendiente',
            estadoCompletado,
            fechaIngreso: fechaRef,
            _original: s
          });
        }
      }

      // 2. SERVICIOS EXTERNOS
      if (this.serviciosExternosOriginales && this.serviciosExternosOriginales.length > 0) {
        for (const s of this.serviciosExternosOriginales) {
          const fechaPago = s.fechaPago || s.fecha_pago || s.fecha || '';
          const fechaCompletado = s.fechaFinalizacion || s.fecha_finalizacion || s.fechaCompletado || '';
          const fechaCreacion = s.fechaCreacion || s.fecha_creacion || s.createdAt || '';

          const coincide = estaEnRango(fechaPago) || estaEnRango(fechaCompletado) || estaEnRango(fechaCreacion);
          if (!coincide) continue;

          const monto = parseFloat(s.montoPagado || s.monto_pagado || s.costo || s.monto || 0);
          const metodo = (s.metodoPago || s.metodo_pago || s.metodo || 'EFECTIVO').toString().toUpperCase();
          const esCredito = metodo.includes('EMPRESA') || metodo.includes('EMPRESARIAL') ||
                            metodo.includes('CORPORATIVO') || metodo.includes('CREDITO') ||
                            metodo.includes('CACHEA') || metodo.includes('CRÉDITO');

          let financiado = 0;
          if (esCredito) financiado = Math.max(0, monto - monto);

          const estado = s.estado || s.nombreEstado || s.estatus || 'Completado';
          const estadoCompletado = estado.toLowerCase().includes('completado') ||
                                   estado.toLowerCase().includes('finalizado') ||
                                   estado.toLowerCase().includes('entregado') ||
                                   estado.toLowerCase().includes('pagado');

          resultado.push({
            id: s.idServicioExterno || s.id || 'N/A',
            numeroOrden: s.idServicioExterno || s.id || 'N/A',
            tipo: 'externo',
            clienteNombre: s.cliente || s.clienteNombre || s.cliente_nombre || 'Cliente',
            metodoPago: s.metodoPago || s.metodo_pago || 'Efectivo',
            totalServicio: monto,
            montoCobradoUsd: monto,
            financiado,
            estado,
            estadoCompletado,
            fechaIngreso: fechaPago || fechaCompletado || fechaCreacion,
            _original: s
          });
        }
      }

      return resultado;
    },

    serviciosExternosFiltrados() {
      return this.serviciosDelPeriodo.filter(s => s.tipo === 'externo');
    },
    serviciosFiltrados() {
      if (this.filtroEstadoServicios === 'todos') return this.serviciosDelPeriodo;
      if (this.filtroEstadoServicios === 'externos') return this.serviciosExternosFiltrados;
      const esCompletado = this.filtroEstadoServicios === 'completado';
      return this.serviciosDelPeriodo.filter(s => s.estadoCompletado === esCompletado);
    },
    serviciosCompletados() {
      return this.serviciosDelPeriodo.filter(s => s.estadoCompletado);
    },
    serviciosPendientes() {
      return this.serviciosDelPeriodo.filter(s => !s.estadoCompletado);
    },
    serviciosPaginados() {
      const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
      return this.serviciosFiltrados.slice(inicio, inicio + this.itemsPorPagina);
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.serviciosFiltrados.length / this.itemsPorPagina));
    },
    totalServiciosCobrado() {
      return this.serviciosDelPeriodo.reduce((sum, s) => sum + (s.montoCobradoUsd || 0), 0);
    }
  },
  async mounted() {
    await this.cargarDatosIniciales();
    await this.cargarEstadisticasPorPeriodo();
  },
  methods: {
    // 🔘 Botones rápidos
    setHoy() {
      const hoy = new Date().toLocaleDateString('sv-SE');
      this.fechaDesde = hoy;
      this.fechaHasta = '';
      this.paginaActual = 1;
      this.cargarEstadisticasPorPeriodo();
    },

    setMesActual() {
      const hoy = new Date();
      const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
      const fmt = (d) => d.toLocaleDateString('sv-SE');
      this.fechaDesde = fmt(primerDia);
      this.fechaHasta = fmt(ultimoDia);
      this.paginaActual = 1;
      this.cargarEstadisticasPorPeriodo();
    },

    setAnioActual() {
      const hoy = new Date();
      this.fechaDesde = `${hoy.getFullYear()}-01-01`;
      this.fechaHasta = `${hoy.getFullYear()}-12-31`;
      this.paginaActual = 1;
      this.cargarEstadisticasPorPeriodo();
    },

    async cargarDatosIniciales() {
      try {
        await Promise.all([this.cargarClientes(), this.cargarTasaUbcv()]);
      } catch (e) { console.error(e); }
    },

    async cargarClientes() {
      try {
        const res = await obtenerClientes();
        if (res.success && res.data) {
          res.data.forEach(c => {
            const nombre = `${c.nombre} ${c.apellido || ''}`.trim();
            this.clientesMap.set(c.idCliente, nombre);
            this.clientesPhoneMap.set(c.idCliente, c.telefono || c.Telefono);
          });
        }
      } catch (e) { console.error(e); }
    },

    async cargarTasaUbcv() {
      try {
        const res = await obtenerTasaVentaActual();
        if (res.success && res.data?.precio_usd_bs) {
          this.tasaUbcv = parseFloat(res.data.precio_usd_bs);
        }
      } catch (e) { console.error(e); }
    },

    resetMetodos() {
      const reset = {
        'Efectivo Bs': 0, 'Efectivo USD': 0, 'Pago Móvil': 0, 'Punto de Venta': 0,
        'Transferencia Bs': 0, 'Transferencia USD': 0,
        'Crédito Cashea': 0, 'Crédito Empresarial': 0
      };
      this.metodosVentas = { ...reset };
      this.metodosServicios = { ...reset };
      this.metodosRecepcionesExpress = { ...reset };
      this.metodosServiciosExternos = { ...reset };
    },

    async cargarEstadisticasPorPeriodo() {
      this.cargandoStats = true;
      const { desde, hasta } = this.rangoPeriodo;

      try {
        this.resetMetodos();
        this.statsPeriodo = { ventas: 0, servicios: 0, recepcionesExpress: 0, serviciosExternos: 0, conteo: 0 };

        const [resVentas, resServicios, resPagosServ, resServiciosExt, resPagosVentas] = await Promise.all([
          obtenerVentas(),
          apiRecepcion.obtenerRecepciones(),
          obtenerPagosSalidaEquipo(),
          apiServiciosExternos.obtenerServicios(),
          obtenerPagosVenta().catch(() => ({ success: false, data: [] }))
        ]);

        const estaEnRango = (fechaStr) => {
          if (!fechaStr) return false;
          const f = String(fechaStr).substring(0, 10);
          return f >= desde && f <= hasta;
        };

        // ---------- VENTAS ----------
        if (resVentas.success) {
          const todasVentas = resVentas.data || [];
          this.ventasOriginales = todasVentas;

          const pagosVentasMap = new Map();
          if (resPagosVentas && resPagosVentas.success && Array.isArray(resPagosVentas.data) && resPagosVentas.data.length > 0) {
            for (const p of resPagosVentas.data) {
              const idV = p.idVenta || p.id_venta;
              if (idV) {
                if (!pagosVentasMap.has(idV)) pagosVentasMap.set(idV, []);
                pagosVentasMap.get(idV).push(p);
              }
            }
          } else {
            const ventasPeriodo = todasVentas.filter(v => {
              const fV = v.fechaVenta || v.fecha_venta || '';
              const esPeriodo = estaEnRango(fV);
              const esCred = ((v.tipoVenta || '') + '').toUpperCase().includes('CREDIT');
              return esPeriodo || esCred;
            });
            const BATCH = 30;
            for (let i = 0; i < ventasPeriodo.length; i += BATCH) {
              const lote = ventasPeriodo.slice(i, i + BATCH);
              const pagosLote = await Promise.all(lote.map(v => obtenerPagosPorVenta(v.idVenta)));
              lote.forEach((v, idx) => {
                const data = (pagosLote[idx].success && pagosLote[idx].data) ? pagosLote[idx].data : [];
                pagosVentasMap.set(v.idVenta, data);
              });
            }
          }

          let totalVentas = 0;
          let conteoVentas = 0;

          for (const v of todasVentas) {
            const fVenta = v.fechaVenta || v.fecha_venta || '';
            const pagos = pagosVentasMap.get(v.idVenta) || [];
            const pagosPeriodo = pagos.filter(p => estaEnRango(p.fechaPago || p.fecha_pago));

            const ventaEnPeriodo = estaEnRango(fVenta);
            if (!ventaEnPeriodo && pagosPeriodo.length === 0) continue;

            let cobrado = pagosPeriodo.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
            if (pagosPeriodo.length === 0 && ventaEnPeriodo) {
              cobrado = parseFloat(v.totalUsd || v.total_usd || 0);
            }

            totalVentas += cobrado;
            conteoVentas++;

            const vTipo = (v.tipoVenta || '').toUpperCase();
            const idC = (v.idTipoCredito || '').toString().toUpperCase();

            if (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) {
              let abonos = 0;
              pagosPeriodo.forEach(p => {
                const m = parseFloat(p.montoUsd || p.monto_usd) || 0;
                const cat = this.clasificarPago(p.tipoPago || p.metodo_pago, p.moneda, m);
                this.metodosVentas[cat] += m;
                abonos += m;
              });

              if (ventaEnPeriodo) {
                const total = parseFloat(v.totalUsd || v.total_usd || 0);
                const financiado = Math.max(0, total - abonos);
                const creditLabel = (idC.includes('CAS') || idC.includes('CACHEA')) ? 'Crédito Cashea' : 'Crédito Empresarial';
                this.metodosVentas[creditLabel] += financiado;
              }
            } else {
              if (pagosPeriodo.length > 0) {
                pagosPeriodo.forEach(p => {
                  const m = parseFloat(p.montoUsd || p.monto_usd) || 0;
                  const cat = this.clasificarPago(p.tipoPago || p.metodo_pago, p.moneda, m);
                  this.metodosVentas[cat] += m;
                });
              } else if (ventaEnPeriodo) {
                const m = parseFloat(v.totalUsd || v.total_usd || 0);
                const cat = this.clasificarPago(v.metodoPago || 'efectivo', 'USD', m);
                this.metodosVentas[cat] += m;
              }
            }
          }

          this.statsPeriodo.ventas = totalVentas;
          this.statsPeriodo.conteo += conteoVentas;
        }

        // ---------- SERVICIOS TALLER ----------
        if (resServicios.success) {
          this.serviciosOriginales = resServicios.data || [];
          this.pagosServicios = resPagosServ.success ? (resPagosServ.data || []) : [];

          const pagosMap = new Map();
          for (const p of this.pagosServicios) {
            const key = p.idRecepcionEquipo || p.id_recepcion_equipo || p.idRecepcion;
            if (key) {
              if (!pagosMap.has(key)) pagosMap.set(key, []);
              pagosMap.get(key).push(p);
            }
          }

          let totalServicios = 0;
          let conteoServicios = 0;

          for (const s of this.serviciosOriginales) {
            const fechaRef = s.fechaPago || s.fechaEntrega || s.fechaIngreso || '';
            const key = s.idRecepcionEquipo ?? s.id_recepcion_equipo ?? s.idRecepcion ?? s.id;
            const pagos = key ? (pagosMap.get(key) || []) : [];
            const pagosPeriodo = pagos.filter(p => estaEnRango(p.fechaPago || p.fecha_pago));
            const creditos = s.creditos || s.cuotas || s.creditosSalidaEquipo || s.cuotasCredito || [];
            const cuotasPeriodo = creditos.filter(c => estaEnRango(c.fechaPago || c.fecha_pago));

            const coincide = estaEnRango(fechaRef) || pagosPeriodo.length > 0 || cuotasPeriodo.length > 0;
            if (!coincide) continue;

            const met = (s.metodoPago || '').toUpperCase();
            const esCredito = met.includes('CREDITO') || met.includes('CACHEA');
            const esCashea = met.includes('CACHEA');
            const esEmpresarial = met.includes('EMPRESA') || met.includes('EMPRESARIAL') || met.includes('CORPORATIVO');

            let cobrado = pagosPeriodo.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
            cobrado += cuotasPeriodo.reduce((sum, c) => {
              return sum + (parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0);
            }, 0);

            const esExpress = (s.tipoDiagnostico || s.TipoDiagnostico || '').toString().toUpperCase().includes('EXPRESS');
            let diagnostico = parseFloat(s.montoPagadoDiagnosticoUsd || 0);
            if (!diagnostico && esExpress && pagosPeriodo.length === 0 && cuotasPeriodo.length === 0) diagnostico = 10;
            if ((pagosPeriodo.length > 0 || cuotasPeriodo.length > 0) && diagnostico > 0) diagnostico = 0;

            let financiado = 0;
            if (esCredito) {
              const totalRep = parseFloat(s.precioTotalUsd || s.montoCobradoUsd || 0);
              if (esCashea) {
                financiado = Math.max(0, totalRep - cobrado);
                if (financiado > 0) this.metodosServicios['Crédito Cashea'] += financiado;
              } else if (esEmpresarial) {
                financiado = Math.max(0, totalRep - cobrado);
                if (financiado > 0) this.metodosServicios['Crédito Empresarial'] += financiado;
              }
            }

            totalServicios += (cobrado + diagnostico);
            conteoServicios++;

            if (pagosPeriodo.length > 0) {
              pagosPeriodo.forEach(p => {
                const m = parseFloat(p.montoUsd || p.monto_usd) || 0;
                if (m > 0) {
                  const cat = this.clasificarPago(p.metodoPago || p.tipoPago, p.moneda || 'USD', m);
                  if (!cat.toLowerCase().includes('crédito')) this.metodosServicios[cat] += m;
                }
              });
            }

            if (cuotasPeriodo.length > 0) {
              cuotasPeriodo.forEach(c => {
                const m = parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0;
                if (m > 0) {
                  const cat = this.clasificarPago(c.metodoPago || c.tipoPago || 'Efectivo', c.moneda || 'USD', m);
                  if (!cat.toLowerCase().includes('crédito')) this.metodosServicios[cat] += m;
                }
              });
            }

            if (pagosPeriodo.length === 0 && cuotasPeriodo.length === 0 && diagnostico > 0) {
              this.metodosServicios['Efectivo USD'] += diagnostico;
            } else if (pagosPeriodo.length === 0 && cuotasPeriodo.length === 0 && !esCredito) {
              const m = parseFloat(s.montoCobradoUsd || s.precioTotalUsd || 0);
              const cat = this.clasificarPago(s.metodoPago || 'Efectivo', 'USD', m);
              if (!cat.toLowerCase().includes('crédito')) this.metodosServicios[cat] += m;
            }
          }

          try {
            const resMin = await obtenerFinanciadoEquiposMinimo(desde, hasta);
            if (resMin) {
              const dataMin = resMin.data || resMin;
              const monto = this.parseMontoFinanciado(dataMin.total);
              if (monto > 0) this.metodosServicios['Crédito Cashea'] = monto;
            }
          } catch (e) { /* fallback */ }

          this.statsPeriodo.servicios = totalServicios;
          this.statsPeriodo.conteo += conteoServicios;

          // ---------- RECEPCIONES EXPRESS ----------
          const expressPeriodo = this.serviciosOriginales.filter(s => {
            const esExpress = (s.tipoDiagnostico || s.TipoDiagnostico || '').toString().toUpperCase().includes('EXPRESS');
            if (!esExpress) return false;
            const fechaIngreso = s.fechaIngreso || '';
            const fechaPago = s.fechaPago || '';
            const montoDiag = parseFloat(s.montoPagadoDiagnosticoUsd || 0);
            const fechaRef = montoDiag > 0 ? (fechaPago || fechaIngreso) : fechaIngreso;
            return estaEnRango(fechaRef);
          });

          let totalExpress = 0;
          let conteoExpress = expressPeriodo.length;

          for (const s of expressPeriodo) {
            const key = s.idRecepcionEquipo || s.id;
            const pagos = pagosMap.get(key) || [];
            const pagosPeriodo = pagos.filter(p => estaEnRango(p.fechaPago || p.fecha_pago));

            let cobrado = 0;
            if (pagosPeriodo.length > 0) {
              cobrado = pagosPeriodo.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
            }
            if (cobrado === 0) cobrado = parseFloat(s.montoPagadoDiagnosticoUsd || 0);
            if (cobrado === 0) cobrado = 10;

            totalExpress += cobrado;

            if (pagosPeriodo.length > 0) {
              pagosPeriodo.forEach(p => {
                const m = parseFloat(p.montoUsd || p.monto_usd) || 0;
                const cat = this.clasificarPago(p.metodoPago || p.tipoPago, p.moneda || 'USD', m);
                if (!cat.toLowerCase().includes('crédito')) this.metodosRecepcionesExpress[cat] += m;
              });
            } else {
              this.metodosRecepcionesExpress['Efectivo USD'] += cobrado;
            }
          }

          this.statsPeriodo.recepcionesExpress = totalExpress;
          this.statsPeriodo.conteo += conteoExpress;
        }

        // ---------- SERVICIOS EXTERNOS ----------
        if (resServiciosExt.success) {
          const todos = resServiciosExt.data || [];
          this.serviciosExternosOriginales = todos;

          const extPeriodo = todos.filter(s => {
            const f1 = s.fechaPago || '';
            const f2 = s.fechaFinalizacion || '';
            return estaEnRango(f1) || estaEnRango(f2);
          });

          let totalExt = 0;
          let conteoExt = extPeriodo.length;

          for (const s of extPeriodo) {
            const monto = parseFloat(s.montoPagado || s.costo || 0);
            const metodo = (s.metodoPago || 'EFECTIVO').toString().toUpperCase();
            const esCredito = metodo.includes('EMPRESA') || metodo.includes('EMPRESARIAL') ||
                              metodo.includes('CORPORATIVO') || metodo.includes('CREDITO') || metodo.includes('CACHEA');

            if (esCredito) {
              if (metodo.includes('CACHEA')) this.metodosServiciosExternos['Crédito Cashea'] += monto;
              else this.metodosServiciosExternos['Crédito Empresarial'] += monto;
            } else {
              totalExt += monto;
              const cat = this.clasificarPago(metodo, 'USD', monto);
              this.metodosServiciosExternos[cat] += monto;
            }
          }

          this.statsPeriodo.serviciosExternos = totalExt;
          this.statsPeriodo.conteo += conteoExt;
        }

        this.paginaActual = 1;
      } catch (error) {
        console.error("Error cargando estadísticas:", error);
      } finally {
        this.cargandoStats = false;
      }
    },

    clasificarPago(metodo, moneda, monto) {
      const m = (metodo || '').toString().toLowerCase();
      const curr = (moneda || '').toString().toUpperCase();

      if (m.includes('cashea') || m.includes('cachea')) return 'Crédito Cashea';
      if (m.includes('empresa') || m.includes('empresarial') || m.includes('corporativo')) return 'Crédito Empresarial';
      if (m.includes('movil') || m.includes('móvil') || m.includes('pago m')) return 'Pago Móvil';
      if (m.includes('punto') || m.includes('debito') || m.includes('débito')) return 'Punto de Venta';
      if (m.includes('transferencia') || m.includes('zelle') || m.includes('bank')) {
        if (curr === 'BS' || curr === 'VES' || m.includes('bs') || m.includes('bolivar')) return 'Transferencia Bs';
        return 'Transferencia USD';
      }
      if (m.includes('efectivo') || m.includes('cash')) {
        if (curr === 'BS' || curr === 'VES' || m.includes('bs') || m.includes('bolivar')) return 'Efectivo Bs';
        return 'Efectivo USD';
      }
      if (curr === 'BS' || curr === 'VES') return 'Efectivo Bs';
      return 'Efectivo USD';
    },

    getBadgeStyle(label) {
      if (label.includes('Efectivo Bs')) return 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400';
      if (label.includes('Efectivo USD')) return 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400';
      if (label.includes('Pago Móvil')) return 'bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400';
      if (label.includes('Punto de Venta')) return 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400';
      if (label.includes('Transferencia Bs')) return 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400';
      if (label.includes('Transferencia USD')) return 'bg-indigo-200 text-indigo-700 dark:bg-indigo-800/30 dark:text-indigo-300';
      if (label.includes('Cashea')) return 'bg-violet-100 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400 font-bold';
      if (label.includes('Empresarial')) return 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400';
      return 'bg-gray-100 text-gray-600';
    },

    getIconStyle(label) {
      if (label.includes('Efectivo')) return 'mdi:cash';
      if (label.includes('Pago Móvil')) return 'mdi:cellphone';
      if (label.includes('Punto')) return 'mdi:credit-card-outline';
      if (label.includes('Transferencia')) return 'mdi:bank-transfer';
      if (label.includes('Cashea')) return 'mdi:lightning-bolt';
      if (label.includes('Empresarial')) return 'mdi:domain';
      return 'mdi:cash-multiple';
    },

    getMetodoPagoClass(metodo) {
      if (!metodo) return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
      const m = metodo.toLowerCase();
      if (m.includes('efectivo')) return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400';
      if (m.includes('transferencia')) return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
      if (m.includes('cashea') || m.includes('crédito')) return 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400';
      if (m.includes('pago móvil') || m.includes('pago movil')) return 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400';
      if (m.includes('punto')) return 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400';
      return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
    },

    getEstadoClass(estado) {
      if (!estado) return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
      const e = estado.toLowerCase();
      if (e.includes('entregado') || e.includes('completado') || e.includes('finalizado') || e.includes('cerrado')) {
        return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400';
      }
      if (e.includes('pendiente')) return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400';
      if (e.includes('cancelado')) return 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400';
      if (e.includes('proceso') || e.includes('reparacion')) return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
      return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
    },

    formatFecha(fecha) {
      if (!fecha) return '—';
      const d = new Date(fecha);
      return d.toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    parseMontoFinanciado(val) {
      if (typeof val === 'number') return val;
      if (!val) return 0;
      const str = String(val);
      const usdMatch = str.match(/\$?\s*([\d\.,]+)\s*USD/i) || str.match(/\$([\d\.,]+)/);
      if (usdMatch && usdMatch[1]) {
        let s = usdMatch[1];
        if (s.includes(',') && s.includes('.')) s = s.replace(/,/g, '');
        else if (s.includes(',')) s = s.replace(',', '.');
        const n = parseFloat(s);
        return isNaN(n) ? 0 : n;
      }
      const n = parseFloat(str.replace(/[^0-9.-]+/g, ''));
      return isNaN(n) ? 0 : n;
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.5);
  cursor: pointer;
}
.dark input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.8);
}
</style>